export default __webpack_public_path__ + "static/media/servicebus.0a0e4a5c.svg";